import { request } from '@/store/client'

/**
  Requests that an expired activate token be re-issued (via Email)
* */
export const resendActivateToken = (email: string): Promise<any> => {
  return request({
    url: `/user/${encodeURIComponent(email)}/resend-activation`,
    method: 'post',
  })
}
